function importAll(r) {
	return r.keys().map(r);
}

const photos = importAll(
	require.context("../images", false, /\.(png|jpe?g|svg)$/)
);

export default photos;
